import React from 'react';
import { Link } from 'react-router';
import eventResolver from '../../../../state/resolvers/event';
import TileSet from '../../../../shared/TileSet';
import LoadableTileSet from '../../../../shared/TileSet/LoadingTileSet';
import EventTile from '../../../../shared/Tiles/EventTile';
import { withTracking } from '../../provider';
import {
  header,
  title as titleStyle,
  container,
  torchRedLink,
  showDesktop,
  showTablet,
} from './styles.module.css';

const LoadingSlice = () => {
  return (
    <div className={container}>
      <LoadableTileSet />
    </div>
  );
};

const Slice = ({ events, title, seeAllUrl, onClick }) => {
  if (events.length < 5) {
    return null;
  }

  return (
    <div className={container}>
      <div>
        <div className={header}>
          <h4 className={titleStyle}>{title}</h4>
          <Link to={seeAllUrl} className={`${torchRedLink} ${showDesktop}`}>
            See all
          </Link>
        </div>
      </div>

      <TileSet>
        {events.map((event, index) => (
          <EventTile
            event={{ ...event, reviewSummary: event.reviews }}
            key={event.id}
            onClick={() =>
              onClick('event', {
                eventId: event.id,
                eventIndex: index,
                slice: title,
                seeAllUrl,
              })
            }
          />
        ))}
      </TileSet>

      <Link to={seeAllUrl} className={`${torchRedLink} ${showTablet}`}>
        See all {title}
      </Link>
    </div>
  );
};

const SportSlices = ({
  slices,
  injected: {
    tracking: { trackButtonClick },
  },
}) => {
  if (!slices || !slices.length) {
    return <LoadingSlice />;
  }

  return slices.map((slice) => {
    const events = slice?.data?.searchEventsV2?.events.map?.(eventResolver);
    return (
      <Slice
        events={events}
        title={slice.title}
        seeAllUrl={slice.seeAllUrl}
        key={slice.title}
        onClick={trackButtonClick}
      />
    );
  });
};

export default withTracking('sport_slice')(SportSlices);
